import { DataType } from '~/common/generated/apollo-operations'
import { ResolvedOptionColor } from '~/common/styles/enum-colors'
import { EnumOptionLite, EnumValueMark } from '~/components/shared/enum-options'

/** How a lookup's enum value renders: chips replace the label, text keeps it and takes a mark */
export type LookupEnumRendering =
  | { kind: 'chips'; values: EnumValueMark[] }
  | { kind: 'text'; color?: ResolvedOptionColor | null; iconName?: string | null }

interface ColumnWithResolvedSource {
  resolvedSourceColumn: {
    column: {
      type: DataType
      innerType: DataType | null
      enumSet: { options: EnumOptionLite[] } | null
    }
  }
}

export interface LookupEnumSource {
  options: EnumOptionLite[]
  isMultiSelect: boolean
}

/** For lookups to enum columns, the source enum's options and whether it is multi-select */
export const enumSourceForLookupColumn = (
  column: ColumnWithResolvedSource | null | undefined,
): LookupEnumSource | null => {
  const target = column?.resolvedSourceColumn.column
  if (!target) {
    return null
  }

  const isMultiSelect = target.type === DataType.ARRAY && target.innerType === DataType.ENUM
  const isEnum = isMultiSelect || target.type === DataType.ENUM
  if (!isEnum) {
    return null
  }

  return { options: target.enumSet?.options ?? [], isMultiSelect }
}
